<template>
 <div class="" id="toMessages">
    <p class="accomplish">消息中心</p>
    <div class="clearfix checkBox">
      <span class="demonstration fl">消息类型：</span>
      <el-radio-group v-model="radio" @change = handleradioChange>
        <el-radio :label="10">全部</el-radio>
        <el-radio :label="1">充值动态</el-radio>
        <el-radio :label="2">提现动态</el-radio>
        <el-radio :label="3">项目动态</el-radio>
        <el-radio :label="5">卡券动态</el-radio>
        <!-- <el-radio :label="7">合伙人动态</el-radio> -->
        <el-radio :label="4">红包动态</el-radio>
        <el-radio :label="6">账号动态</el-radio>
      </el-radio-group>
    </div>
    <div class="block timeBox">
      <span class="demonstration">发送日期：</span>
      <el-date-picker
        :clearable = false
        v-model="value1"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change = 'timeChange'>
      </el-date-picker>
    </div>
    <div class="tabBox">
      <el-table
        :data="tableData"
        style="width: 100%"
        empty-text="当前数据没有，请添加数据">
        <el-table-column
          prop="typeName"
          label="消息类型"
          width="180">
          <template slot-scope="scope">
            <span :class="scope.row.readStatus === 1 ? 'colorFontA5' : 'colorFont32'">{{scope.row.typeName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dealTime"
          label="发送日期"
          width="180">
          <template slot-scope="scope">
            <span :class="scope.row.readStatus === 1 ? 'colorFontA5' : 'colorFont32'"  :title="scope.row.dealTimeTwo">{{scope.row.dealTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题">
          <template slot-scope="scope">
            <span :class="scope.row.readStatus === 1 ? 'colorFontA5' : 'colorFont32'">{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          label="操作">
          <template slot-scope="scope">
            <el-button v-on:click="windowOpen('msgWindowFlag', scope.row)" type="text" size="small">查看</el-button>
            <el-button v-on:click="windowOpen('deleteWindowFlag', scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <div class="emptyBox"></div>
          <p style="color:#5e5e5e;">您暂无{{typesName}}消息！</p>
        </div>
      </el-table>
    </div>
    <div class="block paginationDiv" v-if="total!==0">
      <div>
        <el-pagination
          layout="prev, pager, next"
           @current-change="handleCurrentChange"
          :total=total>
        </el-pagination>
      </div>
      <div class="total">共{{total}}条</div>
    </div>
    <!-- 弹窗 -->
    <div id="msg-model" class="model" v-show="msgWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('msgWindowFlag')"></i>
      <p class="msg-title">{{ dialogMsg.title }}</p>
      <p class="user-name">亲爱的{{userName}}：</p>
      <p class="diaContent">{{ dialogMsg.start }}</p>
      <p class="diaText">发件人：普惠理财</p>
      <p class="diaText" style="margin-top:5px;margin-bottom:14px;">发送时间：<span>{{dialogMsg.sendTime}}</span></p>
    </div>
    <!-- 删除弹窗 -->
    <div id="delete-model" class="model" v-show="deleteWindowFlag">
      <div style="text-align: center;padding-top:60px;margin-bottom:59px;">
        <span style="color: #323232;font-size:16px;">删除此条信息？</span>
      </div>
      <div>
        <div class="dialog-footer">
          <span v-on:click="windowClose('deleteWindowFlag')" class="cancelbtn">取 消</span>
          <span v-on:click="deleteMsg()" class="submitbtn">确 定</span>
        </div>
      </div>
    </div>
 </div>
</template>

<script>
export default {
  data () {
    return {
      radio: 10,
      total: 0,
      typesName: '',
      msgWindowFlag: false,
      deleteWindowFlag: false,
      value1: '',
      tableData: [],
      startTime: null,
      endTime: null,
      dialogVisible: false,
      userName: '',
      dialogMsg: {
        title: '',
        start: '',
        content: '',
        sendTime: ''
      },
      deleteDialogMsg: {
        idArray: 0
      }
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {
      this.userName = res.userName
      /* res :
       * {code: "1"
       *  msg: "用户已登录!"
       *  userId: "20628"
       *  userName: "150****8454"
       * } */
    }).catch(() => {})
    this.getMsgMessageListByType()
  },
  methods: {
    handleradioChange (val) {
      this.radio = val
      this.getMsgMessageListByType()
    },
    windowOpen (flag, arr) {
      if (flag === 'msgWindowFlag') {
        this.seehandleClick(arr)
      } else {
        this.deletehandleClick(arr)
      }
      this[flag] = true
      this.$mask.show()
    },
    windowClose (flag) {
      this[flag] = false
      this.$mask.hide()
    },
    deleteMsg () {
      this.axios({
        url: this.HOST + '/web-server/message/v1/deleteMsgMessage',
        method: 'POST',
        params: this.deleteDialogMsg,
        data: {},
        transformRequest: [function (data, headers) {}],
        transformResponse: [function (data, headers) {
          return JSON.parse(data)
        }]
      }).then((res) => {
        if (res.data.code === 1) {
          this.windowClose('deleteWindowFlag')
          this.getMsgMessageListByType()
          this.$message('删除成功！')
        }
      })
    },
    seehandleClick (row) {
      var params = {}
      params.id = row.id
      this.axios({
        url: this.HOST + '/web-server/message/v1/updateMsgMessageReadStatus',
        method: 'POST',
        params: params,
        data: {},
        transformRequest: [function (data, headers) {}],
        transformResponse: [function (data, headers) {
          return JSON.parse(data)
        }]
      }).then((res) => {
        if (res.data.code === 1) {
          this.getMsgMessageListByType()
        }
      })
      this.dialogMsg.title = row.title2
      this.dialogMsg.start = row.content
      this.dialogMsg.sendTime = new Date(row.sendTime).format('yyyy-MM-dd HH:mm:ss')
      this.dialogVisible = true
    },
    deletehandleClick (row) {
      this.isDeleteDialong = true
      this.deleteDialogMsg.idArray = row.id
    },
    timeChange (value) {
      if (value) {
        this.endTime = new Date(value[1]).format('yyyy-MM-dd')
        this.startTime = new Date(value[0]).format('yyyy-MM-dd')
      } else {
        this.startTime = null
        this.endTime = null
      }
      this.getMsgMessageListByType()
    },
    handleCurrentChange (val) {
      this.page = val
      this.getMsgMessageListByType()
    },
    getMsgMessageListByType () {
      var params = {}
      params.type = this.radio
      params.page = this.page
      params.rows = 10
      params.sendTimeStart = this.startTime
      params.sendTimeEnd = this.endTime
      if (this.radio === 1) {
        this.typesName = '充值动态'
      } else if (this.radio === 2) {
        this.typesName = '提现动态'
      } else if (this.radio === 3) {
        this.typesName = '项目动态'
      } else if (this.radio === 4) {
        this.typesName = '红包动态'
      } else if (this.radio === 5) {
        this.typesName = '卡券动态'
      } else if (this.radio === 6) {
        this.typesName = '账号动态'
      } else if (this.radio === 10) {
        this.typesName = '动态'
      }
      // var that = this
      this.axios({
        url: this.HOST + '/web-server/message/v1/getMsgMessageListByType',
        method: 'GET',
        params: params,
        data: {},
        transformRequest: [function (data, headers) {}],
        transformResponse: [function (data, headers) {
          return JSON.parse(data)
        }]
      }).then((res) => {
        this.tableData = res.data.data.resultInformation
        this.total = res.data.data.total
        this.tableData.forEach(function (value, i) {
          value.dealTime = new Date(value.sendTime).format('yyyy-MM-dd')
          value.dealTimeTwo = new Date(value.sendTime).format('yyyy-MM-dd HH:mm:ss')
          if (value.type === 1) {
            value.typeName = '充值动态'
          } else if (value.type === 2) {
            value.typeName = '提现动态'
          } else if (value.type === 3) {
            value.typeName = '项目动态'
          } else if (value.type === 4) {
            value.typeName = '红包动态'
          } else if (value.type === 5) {
            value.typeName = '卡券动态'
          } else if (value.type === 6) {
            value.typeName = '账号动态'
          } else if (value.type === 9) {
            value.typeName = '其他动态'
          }
          value.title2 = value.title
          if (value.title.length > 10) {
            value.title = value.title.substring(0, 10) + '...'
          }
        })
      })
    }
  },
  components: {

  }
}
</script>
<style lang="less">
  @import url("../../assets/css/accountTotal/toMessages.less");
</style>



// WEBPACK FOOTER //
// src/page/accountTotal/toMessages.vue